import { TanStackDevtools as TanstackDevtoolsPanel } from '@tanstack/react-devtools';
import { FormDevtoolsPlugin } from '@tanstack/react-form-devtools';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';

export function Devtools() {
  return (
    <TanstackDevtoolsPanel
      config={{ hideUntilHover: true }}
      plugins={[
        {
          name: 'Query',
          render: <ReactQueryDevtoolsPanel />,
        },
        {
          name: 'Router',
          render: <TanStackRouterDevtoolsPanel />,
        },
        FormDevtoolsPlugin(),
      ]}
    />
  );
}

export const TanstackDevtools = process.env.NODE_ENV === 'development' ? Devtools : () => null;
